import React from "react";
import CollapsibleSection from "./CollapsibleSection";

const DealershipOverviewPanel = ({
    isOpen,
    onToggle,
    formData,
    setFormData,
    handleGenerateAI,
    loadingAI
}) => {
    const overview = (formData.description || '').trim().replace(/\s+/gu, ' ');
    const validOverview = overview.length >= 100 && overview.length <= 300 && /[\p{L}\p{N}]/u.test(overview);
    return (
        <CollapsibleSection
            title="🧭 Dealership Overview"
            isOpen={isOpen}
            onToggle={onToggle}
        >
            <div className="form-section dealership-overview">
                <small className="note overviewNote">
                    Tell customers what makes your dealership stand out. Highlight services, specialties, or experience.
                </small>
                <div className="description-text">
                    <textarea
                        id="description"
                        name="description"
                        className="description-textarea"
                        placeholder="Briefly describe your shop, services, specialties..."
                        maxLength={300}
                        aria-required="true"
                        aria-invalid={!validOverview}
                        aria-describedby={validOverview ? "overview-counter" : "overview-counter overview-validation"}
                        value={formData.description || ""}
                        onChange={(e) =>
                            setFormData({ ...formData, description: e.target.value })
                        }
                    />
                    <div className="overview-counter-row">
                        <span id="overview-counter" className="description-counter" aria-live="polite">
                            {overview.length}/300 characters (minimum 100)
                        </span>
                    </div>
                    <div className="overview-ai-row">
                        <button
                            type="button"
                            className="ai-generate-button"
                            onClick={handleGenerateAI}
                            disabled={loadingAI}
                        >
                            {formData.description ? "Re-generate with AI" : "Generate with AI"}
                        </button>
                    </div>
                    {!validOverview && (
                        <small id="overview-validation" className="note overviewNote overview-validation" role="status">
                            Enter 100–300 meaningful characters to save changes. Extra whitespace does not count.
                        </small>
                    )}
                </div>
            </div>
        </CollapsibleSection>
    );
};

export default DealershipOverviewPanel;